export const response_enviar_codigo = {
  description: 'Código enviado',
  schema: {
    properties: {
      message: { type: 'string', example: 'Código enviado exitosamente' },
      data: { type: 'array' },
      expiracion: { type: 'string', example: '2025-11-04 16:41:24' },
    },
  },
};

export const response_verificar_codigo = {
  description: 'Código verificado',
  schema: {
    properties: {
      message: { type: 'string', example: 'Código verificado exitosamente' },
      data: { type: 'array' },
    },
  },
};
